import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { theme } from "antd";
import { observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { __ } from "../../../../utils/i18n.js";
// `getLabel` returns a static `__()` call so the strings are extracted into the
// translation catalog. A dynamic `__(variable)` is NOT picked up by the i18n
// extractor and would silently fall back to English.
const TABS = [
    {
        key: "subscriptions",
        getLabel: ()=>__("Subscriptions and Licenses")
    },
    {
        key: "invoices",
        getLabel: ()=>__("Invoices")
    },
    {
        key: "details",
        getLabel: ()=>__("Account details")
    },
    {
        key: "affiliate",
        getLabel: ()=>__("Affiliate")
    }
];
const TabStrip = observer(()=>{
    const { token } = theme.useToken();
    const navigate = useNavigate();
    const [, tab] = useLocation().pathname.split("/");
    const activeKey = tab ?? "";
    // CSS has no `:stuck` pseudo-class. A 0-px sentinel placed directly
    // above the nav lets us derive the docking moment: while it's in view
    // the nav still sits at its natural position; once it scrolls out, the
    // nav has docked and the `--stuck` modifier flips on so the backdrop
    // switches to its docked styling.
    const sentinelRef = useRef(null);
    const [isStuck, setIsStuck] = useState(false);
    useEffect(()=>{
        const sentinel = sentinelRef.current;
        if (!sentinel || typeof IntersectionObserver === "undefined") {
            return undefined;
        }
        const observer = new IntersectionObserver(([entry])=>{
            if (entry) {
                setIsStuck(!entry.isIntersecting);
            }
        }, {
            threshold: 0
        });
        observer.observe(sentinel);
        return ()=>observer.disconnect();
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                ref: sentinelRef,
                "aria-hidden": true,
                className: "rc-account-v2-tabnav__sentinel"
            }),
            /*#__PURE__*/ _jsxs("nav", {
                className: `rc-account-v2-tabnav${isStuck ? " rc-account-v2-tabnav--stuck" : ""}`,
                "aria-label": __("Customer Center sections"),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        "aria-hidden": true,
                        className: "rc-account-v2-tabnav__backdrop"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "rc-account-v2-tabnav__inner",
                        children: TABS.map(({ key, getLabel })=>{
                            const isActive = activeKey === key;
                            return /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: `rc-account-v2-tabnav__item${isActive ? " rc-account-v2-tabnav__item--active" : ""}`,
                                style: {
                                    color: isActive ? token.colorPrimary : token.colorTextSecondary,
                                    borderBottomColor: isActive ? token.colorPrimary : "transparent"
                                },
                                onClick: ()=>navigate(`/${key}`),
                                "aria-current": isActive ? "page" : undefined,
                                children: getLabel()
                            }, key);
                        })
                    })
                ]
            })
        ]
    });
});
export { TabStrip };
